import { useMemo } from "react";
import { DictionaryRecord, useDictionaries } from "../../toolympus/hooks/useDictionaries";

export const ProjectStateDictName = "ProjectState";

interface ProjectStateExtra {
  color?: string;
  is_starting?: boolean;
  is_inprogress?: boolean;
  is_hold?: boolean;
  is_focus?: boolean;
  is_finished?: boolean;
  is_applicable_for_stage?: boolean;
}

interface ProjectState extends Omit<DictionaryRecord, "extra"> {
  extra?: ProjectStateExtra;
}

export const useProjectStates = () => {
  const dicts = useDictionaries();
  const projectStateDict = dicts[ProjectStateDictName];

  const x = useMemo(() => {
    return {
      records: projectStateDict.records as ProjectState[] || [],
      byCode: (projectStateDict.records as ProjectState[] || []).reduce<Record<string, ProjectState>>((r,rec) => {
        r[rec.code] = rec;
        return r;
      }, {}),
      defaultProjectState: (projectStateDict?.records?.filter(x => x.extra?.is_starting) || [])[0],
    }
  }, [projectStateDict.records]);

  return x;
}
